export default __webpack_public_path__ + "images/NI.af44f38.png";